<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card class="pb-5">
        <v-card-title class="text-uppercase">
          <h5>Update Account</h5>
        </v-card-title>
        <v-card-text>
          <v-form class="mt-3" v-model="valid" @submit.prevent="updateAccount">
            <v-row>
              <v-col cols="5">
                <v-select
                  :items="titles"
                  outlined
                  label="Title *"
                  :rules="rules.required"
                  v-model="user.title"
                ></v-select>
              </v-col>
              <v-col cols="7">
                <v-text-field
                  outlined
                  label="First Name *"
                  :rules="rules.required"
                  v-model="user.firstName"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              outlined
              label="Last Name *"
              :rules="rules.required"
              v-model="user.lastName"
            ></v-text-field>

            <v-combobox
              v-model="user.institution"
              :items="institutions"
              item-text="name"
              item-value="name"
              label="Institution name *"
              outlined
              :return-object="false"
              :rules="rules.required"
            ></v-combobox>

            <v-text-field
              outlined
              label="Department / College *"
              :rules="rules.required"
              v-model="user.department"
            ></v-text-field>

            <v-text-field
              outlined
              label="Specialization (optional)"
              v-model="user.specialization"
            ></v-text-field>

            <v-divider class="mb-7"></v-divider>

            <v-text-field
              outlined
              label="Email *"
              :rules="rules.required"
              v-model="user.email"
            ></v-text-field>

            <v-text-field
              outlined
              label="Phone number (optional)"
              v-model="user.phone"
              hide-details
            ></v-text-field>

            <v-divider class="mb-7"></v-divider>

            <v-select
              :rules="rules.required"
              v-model="user.roles"
              :items="USER_ROLES"
              label="Roles *"
              outlined
              multiple
              chips
            ></v-select>

            <v-select
              :rules="rules.required"
              v-model="user.status"
              :items="USER_STATUSES"
              label="Status *"
              outlined
            ></v-select>

            <v-checkbox
              class="mt-0"
              color="green"
              v-model="user.active"
              label="Active user"
            >
            </v-checkbox>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDialog"> Cancel </v-btn>
              <v-btn
                text
                type="submit"
                color="green lighten-1"
                @click="updateAccount"
                :disabled="!valid"
              >
                Save update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { required } from "../../../../tools/rules";
import { USER_STATUSES, USER_TITLES } from "../../../../tools/specs";
import Institutions from "../../../../data/world_universities_and_domains-min.json";

const USER_ROLES = [
  // { text: "AUTHOR", disabled: true },
  { text: "AUTHOR" },
  { text: "REVIEWER" },
  { text: "EDITOR" },
  { text: "PUBLISHER" },
];

export default {
  props: ["account"],

  data: () => ({
    dialog: false,
    user: {
      title: null,
      firstName: null,
      lastName: null,
      institution: null,
      department: null,
      specialization: null,
      email: null,
      phone: null,
    },

    valid: false,
    rules: {
      required,
    },

    titles: USER_TITLES,
    institutions: Institutions,
    USER_ROLES,
    USER_STATUSES,
  }),

  watch: {
    account: {
      handler(value) {
        this.findAccount(value);
      },
    },
  },

  methods: {
    closeDialog() {
      this.$emit("cancel");
      this.dialog = false;
    },
    confirmSuggestion() {
      this.$emit("suggest", this.account);
      this.dialog = false;
    },
    findAccount(account) {
      if (!account) return;

      this.$axios
        .get(`/users/${this.account}`)
        .then(({ data: response }) => {
          this.user = response;
          this.dialog = true;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not load account",
          });
          this.dialog = false;
        });
    },
    updateAccount(account) {
      if (!account) return;

      this.$axios
        .put("/users", this.user)
        .then(() => {
          this.dialog = false;
          this.$emit("refresh");
          this.$emit("cancel");
          this.$bus.$emit("snackbar", {
            type: "info",
            message: "Account has been updated",
          });
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not update account",
          });
          this.dialog = false;
        });
    },
  },
};
</script>